const DEFAULT_CAP = 100;

/**
 * Process-wide record of paymentRequestIds the CDS has already terminally
 * handled (completed or cancelled). Bounded FIFO — past the cap the oldest
 * entry is evicted, so it stays memory-safe on an always-on CDS while still
 * remembering recent requests long enough to cover a POS kill-and-reopen
 * re-broadcast. Stops such a re-broadcast from re-launching a payment/tip the
 * customer already dealt with here.
 */
class HandledPaymentRequests {
  private readonly ids = new Set<string>();

  constructor(private readonly cap: number = DEFAULT_CAP) {}

  has(paymentRequestId: string): boolean {
    return this.ids.has(paymentRequestId);
  }

  add(paymentRequestId: string): void {
    this.ids.add(paymentRequestId);
    if (this.ids.size > this.cap) {
      // Set preserves insertion order, so the first entry is the oldest.
      this.ids.delete(this.ids.values().next().value as string);
    }
  }

  clear(): void {
    this.ids.clear();
  }
}

export const handledPaymentRequests = new HandledPaymentRequests();
